import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
// Self-hosted brand typography
import '@fontsource-variable/figtree';
import '@fontsource-variable/space-grotesk';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#242424',
            color: '#FFFAF6',
            border: '1px solid #333333',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '14px',
            fontFamily: '"Figtree Variable", system-ui, sans-serif',
          },
          success: {
            iconTheme: { primary: '#22C55E', secondary: '#242424' },
          },
          error: {
            iconTheme: { primary: '#FF5D8F', secondary: '#242424' },
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
